import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { PropOptions } from 'vue';
import FieldValidationErrors from '@/components/errors/FieldValidationErrors.vue';

@Component({
    name: 'Consent',
    components: {
        FieldValidationErrors
    }
})
export default class ConsentInput extends Vue {
    @Prop({ required: true } as PropOptions<string>)
    policyName!: string;

    @Prop({ required: true } as PropOptions<string>)
    policyUrl!: string;

    @Prop({ required: false, default: null } as PropOptions<string>)
    label!: string;

    @Prop({ required: true, default: null } as PropOptions<string>)
    errorMessage!: string;

    @Inject('validator')
    $validator: any;

    consentToPolicy: boolean = false;

    created() {
        this.$validator.extend('consent', { getMessage: this.getInvalidMessage, validate: (value: boolean) => value }, { validatesRequired: true });
    }

    get getInvalidMessage() {
        if (this.errorMessage === null) {
            return `You must consent to the ${this.policyName} to continue.`;
        } else {
            return this.ReplaceTokens(this.errorMessage, false);
        }
    }

    get inputFieldName() {
        return 'agree_to_' + this.policyName.replace(/\s/g, '_').replace(/[^\w\s]/, '').toLowerCase();
    }

    get customLabel() {
        if (this.label === null) {
            return null;
        }

        return this.ReplaceTokens(this.label, true);
    }

    ReplaceTokens = (str: string, html: boolean) => {
        let r = str.replace(/\[\[PolicyUrl]]/gi, this.policyUrl).replace(/\[\[PolicyName]]/gi, this.policyName);

        if (!html) {
            return r;
        }

        return r.replace(/\[\[PolicyLink]]/gi, `<a href="${this.policyUrl}" target="_blank">${this.policyName}</a>`);
    }
}